var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 302,
    viewBox: "0 0 248 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_1410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 249,
    height: 302
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 249,
    height: 302,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M84.9889 81.944C118.292 36.1353 181.12 27.7054 225.321 63.1154C269.521 98.5253 278.355 164.366 245.052 210.175L57.0629 468.757L-103 340.526L84.9889 81.944Z",
    fill: "#57AF98"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M171.637 49.9441C204.94 4.13535 267.769 -4.29457 311.969 31.1154C356.169 66.5253 365.003 132.366 331.7 178.175L123.88 464.036L-36.1833 335.805L171.637 49.9441Z",
    fill: "#57AF98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarbg);
export default __webpack_public_path__ + "static/media/sidebarbg.c4a56c8b5326bfdb6c114f06cb38f5f5.svg";
export { ForwardRef as ReactComponent };